import { render, staticRenderFns } from "./edit-point.vue?vue&type=template&id=f1c4e258&"
import script from "./edit-point.vue?vue&type=script&lang=ts&"
export * from "./edit-point.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports